module.exports = __webpack_public_path__ + "img/create-treatment-button-ru.5e2a45ab.png";